export enum PlanningStatus {
  pending = 'pending',
  approved = 'approved',
  produced = 'produced',
  rejected = 'rejected',
  canceled = 'canceled',
  control = 'control',
  issued = 'issued',
  delivered = 'delivered',
  inbox = 'inbox',
}
